var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['pill-tabs', ..._vm.variantClassList]},[_c('div',{staticClass:"pill-tabs__header-container"},[_c('div',{staticClass:"pill-tabs__header"},[_c('ul',{class:['pill-tabs__header-items']},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.index,class:[
						'pill-tabs__header-item',
						_vm.currentTabIndex === tab.index && 'is-active',
						tab.disabled && 'no-interactive',
						tab.hasError && 'has-error'
					],attrs:{"tabindex":"0"},on:{"click":function($event){!tab.disabled ? _vm.onTabClick(tab.index) : null}}},[_c('div',{class:[
							'pill-tabs__header-element',
							tab.disabled && 'is-disabled'
						]},[(
								_vm.$slots['headerItem' + tab.index] ===
									undefined
							)?_c('div',{staticClass:"pill-tabs__header-element-content"},[(tab.title)?_c('span',{staticClass:"pill-tabs__title"},[_vm._v(" "+_vm._s(tab.title)+" "),(
										(tab.indicator ||
											tab.tabIcon ||
											tab.indicatorValue ||
											tab.hasError) &&
											_vm.$slots[
												'headerItem' + tab.index
											] === undefined
									)?_c('TabIconBadge',{attrs:{"indicator":(tab.hasError ? 'error' : tab.indicator),"tabIcon":tab.tabIcon,"dataBg":tab.dataBg,"dataColor":tab.dataColor,"indicatorValue":tab.indicatorValue}}):_vm._e()],1):_vm._e()]):_vm._e(),_vm._t('headerItem' + tab.index)],2)])}),0)])]),_c('div',{staticClass:"pill-tabs__tab-content"},[_vm._t(_vm.currentTabIndex)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }